/* ==========================================================================
   C700K — Cinematic intro sequence
   Plays once per browser session on first visit to the homepage.
   ========================================================================== */

(function () {
  'use strict';

  var intro = document.getElementById('CinematicIntro');
  if (!intro) return;

  var STORAGE_KEY = 'c700k_intro_seen';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || sessionStorage.getItem(STORAGE_KEY)) {
    intro.classList.add('is-done');
    document.body.style.overflow = '';
    return;
  }

  document.body.style.overflow = 'hidden';

  var lines = intro.querySelectorAll('[data-line]');
  var skipBtn = document.getElementById('CinematicIntroSkip');
  var stepDelay = 1600;
  var currentStep = 0;
  var timers = [];

  function showStep(index) {
    lines.forEach(function (el) { el.classList.remove('is-active'); });
    if (lines[index]) lines[index].classList.add('is-active');
  }

  function finish() {
    timers.forEach(clearTimeout);
    intro.classList.add('is-done');
    document.body.style.overflow = '';
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  lines.forEach(function (_, i) {
    timers.push(setTimeout(function () { showStep(i); }, i * stepDelay + 300));
  });

  timers.push(setTimeout(finish, lines.length * stepDelay + 1400));

  if (skipBtn) {
    skipBtn.addEventListener('click', finish);
  }

  intro.addEventListener('click', function (e) {
    if (e.target === intro) finish();
  });
})();
